module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo14-bd983ffaff6857d27c13e2eafcb665de.jpg";